var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 0.249758L3.125 0.249756C1.64844 0.249756 0.5 1.45288 0.5 2.87476L0.499998 22.1248C0.499998 23.6013 1.64844 24.7498 3.125 24.7498L22.375 24.7498C23.7969 24.7498 25 23.6013 25 22.1248L25 2.87476C25 1.45288 23.7969 0.249758 22.375 0.249758ZM19.3672 16.1091C19.6406 16.3279 19.6406 16.7654 19.3672 17.0388L17.2344 19.1716C16.9609 19.4451 16.5234 19.4451 16.3047 19.1716L12.75 15.5623L9.14062 19.1716C8.92187 19.4451 8.48437 19.4451 8.21094 19.1716L6.07812 16.9841C5.80469 16.7654 5.80469 16.3279 6.07812 16.0544L9.6875 12.4998L6.07812 8.94507C5.80469 8.72632 5.80469 8.28882 6.07812 8.01538L8.26562 5.88257C8.48437 5.60913 8.92187 5.60913 9.19531 5.88257L12.75 9.43726L16.3047 5.88257C16.5234 5.60913 16.9609 5.60913 17.2344 5.88257L19.3672 8.01538C19.6406 8.28882 19.6406 8.72632 19.3672 8.94507L15.8125 12.4998L19.3672 16.1091Z",
    fill: "#ED1651"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastFail);
export default __webpack_public_path__ + "static/media/toast-fail.99952b017cb6b8d48e2c55178bad939d.svg";
export { ForwardRef as ReactComponent };